<span class="heading">
  <mat-icon (click)="infoClicked($event)" *ngIf="helpInfo"  svgIcon="information-outline"></mat-icon>
  <span [innerHTML]="title"></span>
</span>

<a [hidden]="!collapsible || disabled" mat-mini-fab class="icon toggle" color="primary">
  <mat-icon *ngIf="selected" svgIcon="x"></mat-icon>
  <mat-icon *ngIf="!selected" [svgIcon]="openIcon"></mat-icon>
</a>

<div style="width: 100%">
  <ng-content></ng-content>
</div>
